module.exports = __webpack_public_path__ + "img/pic_1.ab162ec4.png";